import { render, staticRenderFns } from "./DashboardTeacher.vue?vue&type=template&id=43486398&"
import script from "./DashboardTeacher.vue?vue&type=script&lang=ts&"
export * from "./DashboardTeacher.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardTeacher.vue?vue&type=style&index=0&id=43486398&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports